import {
  DoGood,
  InternalHero,
  PetLandingPageType,
  Pricing,
  Questions,
  Reviews,
  TakeBetterCare,
  ValuePoints,
  WhatIsCovered,
} from '@/components/pet';
import { PageWrapper } from '@/components/shared/Content';
import Layout from '@/components/shared/Layout';
import { SEO } from '@/components/shared/SEO';
import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/pet/cats/us/en';
import { PET_LANDING_PAGE } from '@/utils/productAdaPages';
import { PRODUCT_PET } from '@/utils/products';
import { useEffect } from 'react';

const extraAnalyticsParams = {
  pet_lp_type: PetLandingPageType.Cat,
  variant: PetLandingPageType.Cat,
};

export default function CatsPage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: want to track event only once
  useEffect(
    () =>
      trackEventWithGeolocation('pet_landing_page.viewed', {
        ...extraAnalyticsParams,
      }),
    [],
  );

  return (
    <Layout
      headerActions={config.layout.headerActions}
      product={PRODUCT_PET}
      page={PET_LANDING_PAGE}
      productType={PRODUCT_PET}
      menuCheckPricesExtraAnalyticsParams={{
        ...extraAnalyticsParams,
      }}
    >
      <SEO {...config.seo} />
      <PageWrapper>
        <InternalHero petLandingPageType={PetLandingPageType.Cat} />
        <ValuePoints petLandingPageType={PetLandingPageType.Cat} />
        <WhatIsCovered petLandingPageType={PetLandingPageType.Cat} />
        <TakeBetterCare petLandingPageType={PetLandingPageType.Cat} />
        <Pricing petLandingPageType={PetLandingPageType.Cat} />
        <Reviews petLandingPageType={PetLandingPageType.Cat} />
        <Questions petLandingPageType={PetLandingPageType.Cat} />
        <DoGood petLandingPageType={PetLandingPageType.Cat} />
      </PageWrapper>
    </Layout>
  );
}
